import LabGroupTabs from './labGroupTabs.js';

new LabGroupTabs(document.querySelector('[data-fade-tabs]'));
